import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSsrnComponent } from './simple-icons-ssrn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSsrnComponent ],
    exports:      [ SimpleIconsSsrnComponent ],
    bootstrap:    []
})
export class SimpleIconsSsrnModule {}
